import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setDairyHerdSize } from "services";

import { GET_DAIRY_HERD_SIZE } from "consts";

import { FootprintingDairyHerdSize, UploadableHerdSize } from "models";

export const useMutateFootprintingDairyHerdSize = (primaryDataId: string) => {
  const queryClient = useQueryClient();

  return useMutation<FootprintingDairyHerdSize[], Error, UploadableHerdSize[]>({
    mutationFn: (data) => setDairyHerdSize(primaryDataId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_DAIRY_HERD_SIZE, primaryDataId] });
    },
  });
};
